export default __webpack_public_path__ + "static/media/gold-medal.5d22be6e.png";